<kt-portlet>

	<kt-portlet-header [title]="title" [class]="'kt-portlet__head--lg'">

	</kt-portlet-header>
	<!-- end::Header -->

	<kt-portlet-body>

		<!-- start::FILTERS & GROUP ACTIONS -->
		<div class="kt-form kt-margin-b-30" *ngIf="showFilter">
			<!-- start::FILTERS -->
			<div class="kt-form__filtration">
				<div class="row align-items-center">
					<div class="col-xl-4 col-md-6 col-sm-12">
						<mat-form-field>
							<!-- <input matInput placeholder="Log Description" formControlName="logDesc" class="mat-form-field mat-form-field-fluid"> -->
							<input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter" class="mat-form-field mat-form-field-fluid">
							<!-- <mat-select placeholder="Log Description" formControlName="logDesc" class="mat-form-field mat-form-field-fluid" multiple>
								<mat-option *ngFor="let item of opts" value="{{item.log_code}}">{{item.log_msg}}</mat-option>
							</mat-select> -->

							<mat-hint align="start">
								<strong>Search by Issue</strong>
							</mat-hint>
						</mat-form-field>
					</div>

					<!-- <div class="col-xl-4 col-md-6 col-sm-8">
						<button [disabled]="!searchForm.valid" mat-raised-button type="submit" color="primary">
							<mat-icon class="mt-1">search</mat-icon>
							Search
						</button>
					</div> -->
				</div>
			</div>
			<!-- end::FILTERS -->
		</div>
		<!-- end::FILTERS & GROUP ACTIONS -->

		<div class="mat-table__wrapper">

			<mat-table class="lmat-elevation-z8"
				#table
				[dataSource]="dataSource"
				matSort
				matSortActive="time_stamp"
				matSortDirection="desc"
				matSortDisableClear>

				<ng-container matColumnDef="log_msg">
					<mat-header-cell *matHeaderCellDef>Issue</mat-header-cell>
					<mat-cell *matCellDef="let issue">
						{{issue.log_msg}}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="time_stamp">
					<mat-header-cell mat-sort-header *matHeaderCellDef>Date</mat-header-cell>
					<mat-cell *matCellDef="let issue">
						{{issue.time_stamp | date:'MM/dd/yy hh:mm:ss a'}}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="clear">
					<mat-header-cell *matHeaderCellDef>Clear Issue</mat-header-cell>
					<mat-cell *matCellDef="let issue">
						<button mat-icon-button color="warn" (click)="clear(issue)">
							<mat-icon>clear</mat-icon>
						</button>
					</mat-cell>
				</ng-container>

				<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
				<mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
			</mat-table>
			<div class="mat-table__message" *ngIf="(!(loading) && empty)">No records found</div>
			<div class="mat-table__message" *ngIf="loading">Please wait....</div>
		</div>


		<div class="mat-table__bottom">
			<!-- <mat-spinner [diameter]="20" *ngIf="dataSource.loading$ | async"></mat-spinner> -->
			<mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 50, 100]"  [showFirstLastButtons]="true"></mat-paginator>
		</div>
	</kt-portlet-body>

</kt-portlet>
